export default "__VITE_ASSET__CAyod1n4__"